module.exports = __webpack_public_path__ + "static/media/background-8.2a43e4cd.jpg";